var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g2, _g3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivationError01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 962.7 599.2"
    },
    viewBox: "0 0 962.7 599.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#025b59}.st2{fill:#f99747}.st8{fill:#fff}.st9{fill:#e1e1e1}.st10{fill:#375a64}.st11{fill:#1a2e35}.st12{fill:#ececec}.st13{opacity:.6}.st15{fill:#b25f57}.st16{fill:#884540}.st17{opacity:.3}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255 440v-23h-89 1v23h-1 64a1412 1412 0 0 0 24 0h1-25l-64 1v-25h90v24h-1z",
    className: "st9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268 417v-2l-1-5v-17l-53 1v-1 24-1h50l3 1h1-54v-24c-1 0 0-1 0 0h54v24zM386 85v-7l-1-17h1l-89 1v-1 24-1h63a1412 1412 0 0 0 24 1h2-90V61l1-1 89 1v24z",
    className: "st9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M398 61v-6l-1-18 1 1h-54l1-1v24l-1-1 39 1h11a25 25 0 0 1 4 0h-15l-39 1V37h54v24zM682 145h85v23h-85zM733 191v-6l-1-17 1 1h-86 1v22h-1 61a1298 1298 0 0 0 23 0h2-86v-23 1-1h86v23zM411 576v-1l-1-5v-16h1-86 1v22h-1 61a1298 1298 0 0 0 23 0h2-25l-61 1v-24h85l1 1v22zM641 41V19h-85s-1 0 0 0v22h61a1298 1298 0 0 0 23 0h1-24l-61 1h-1V19l1-1h85v23zM753 337v-22h-85v22h61a1298 1298 0 0 0 23 0h1-24l-61 1h-1l1-1v-23h86v1l-1 16v6z",
    className: "st9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247 86h403v453H247z",
    className: "st10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m247 86 3 2a149 149 0 0 1 13 14l-7-7-6-6-3-3zM650 86zM265 519z",
    className: "st11"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264 104h368v418H264z",
    className: "st12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M633 522H264V103h369v419zm-368-1h366V104H265v417z",
    className: "st11"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627 237c-1-8-1-17-4-24-3-8-9-15-16-18-6-2-11-1-17-1-12 2-23 4-33 9-20 10-29 34-33 56s0 45 9 66 16 37 32 53c-9 14-12 33-6 49l3 12c-1 8-9 12-12 19-3 6-3 13-3 20s-1 15-6 19l-12 4c-4 1-8 4-9 8l3 11 60-1 32-40 18-92-6-150z",
    className: "st8"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M423 441zM521 410a448 448 0 0 1 17-15l-17 15zM533 464zM487 354zM582 411zM290 344zM299 157zM375 368zM351 499zM465 495zM479 217z",
    className: "st9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M548 164zM316 251zM294 412zM379 448zM528 227zM462 312zM548 349zM406 501z",
    className: "st8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M535 277zM381 164zM504 148zM411 211zM436 152zM299 468zM323 182z",
    className: "st9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m272 514 353-2-1 1V111h1-353v403l-1-403h354v402l-353 1z",
    className: "st8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M449 520zM636 297z",
    className: "st11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M373 275c5-1 8-6 13-7 10-2 18 8 27 10 8 1 15-2 22-6 7-3 13-7 21-7s16 6 15 13c0 6-6 11-11 15-5 5-8 12-4 17 4 4 12 3 14 10 0 4 0 7-2 10-4 6-10 9-15 14-4 4-6 11-2 16l4 3c5 6 4 15 0 21-5 6-11 10-17 14s-12 10-13 17c-2 9 3 18 2 27-1 14-17 24-29 19l-13-5c-7-2-14 2-21 4s-14 6-20 2c-10-7-8-24-18-30-8-6-21 0-27-8-3-4-3-9-2-14 2-4 4-9 4-13 1-15-15-26-15-40 0-9 6-17 13-23 6-6 14-11 19-19 5-7 6-17 11-25 6-10 17-16 28-16l8 1h8z",
    className: "st8",
    style: {
      opacity: 0.7
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M351 345c-3 0-5 3-5 6 1 3 4 5 7 5 3-1 5-4 4-7 0-3-3-5-6-4zM388 348c3-1 4-4 4-7-1-3-4-5-7-4s-5 4-4 7 4 5 7 4zM368 370l8-4 8 1 4 1 3 2 5 5v-2l-3-5-4-3a21 21 0 0 0-14-3 20 20 0 0 0-15 12l-2 5 1 3v-1l3 8 1 2 1-1v-2l-2-8 1 2h2v-1l-1-8v-1l4-2z",
    className: "st12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M427 349c-2-12-10-23-20-31-6-4-13-8-20-10-10-3-20-3-29-1-13 3-24 11-31 24-5 9-7 20-7 30l-1 7 3 9 6 13 5 9 11 7 12 5 3 7c0 2 1 3 2 3 2 0 2-2 3-3 5 5 3 15 8 21l2 1 1-3-3-24h1a52 52 0 0 0 23-5v-2l-2-1-10 4c-13 2-26 0-37-7s-19-18-22-31c-6-27 7-53 30-60l2-1h2l1 3 1 7 2 2 2-2v-5c-1-2-1-4 1-4h2l4-2 14 2c6 2 13 5 18 10 11 7 18 17 20 28 0 1 1 2 2 1 1 0 2 0 1-1z",
    className: "st12"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m272 111-4-3-3-4 3 3 4 4z",
    className: "st8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420 512c0-8-10-11-18-13-8-1-16 0-23-4-5-2-8-5-12-8-6-4-13-5-20-4-4 0-8 2-12 0-5-2-6-7-8-11-9-22-31-33-53-27l1 67h145z",
    className: "st8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490 115c1 5-6 10-10 12-5 2-11 2-16 2-5-1-11-2-16-1-7 1-13 5-19 7-11 3-22 0-32-3-11-3-23-4-32 1-8 5-14 15-23 18-5 1-11 0-16 2-7 3-9 11-11 18-1 7-2 15-7 20-5 4-10 5-15 8-6 6-7 15-7 24-1 14 1 28 1 42 0 15-3 29-11 41l1-191h213z",
    className: "st8"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m701 339-7-23-4-24-24 70a84072 84072 0 0 1 3 33c2 2 5 1 7-1 18-11 29-34 25-55z",
    className: "st11"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m636 244-46-10-12 3c-25 4-38 35-35 56 4 23 9 51 15 67 13 33 40 32 40 32l3 21a37 37 0 0 0 72-11l-24-148c-1-6-7-11-13-10z",
    className: "st15"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M557 316c0 3 3 4 5 4 3-1 4-3 4-5-1-2-3-4-5-3-3 0-4 2-4 4zM552 305c1 1 3-3 8-4h9l-2-2h-8c-3 0-5 2-6 3l-1 3zM589 336h-8l-2-1v-3a1115 1115 0 0 0-1-11l-1 10v5l2 1h3l7-1z",
    className: "st11"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M598 392s23-4 43-22c0 0-7 26-42 30l-1-8zM606 341c-1-2-4-2-6-2l-5 5 2 7v1h8l3-1 1-4c0-2-1-5-3-6z",
    className: "st16"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M595 354c1 0 1-5 6-8s11-2 11-3l-4-1c-2-1-5 0-8 2-3 1-5 4-6 6l1 4zM562 285c-1-1-3 2-6 4l-7 5 3 1c2 0 4 0 6-2l4-5v-3zM610 305c0 2-1 5-4 5-2 1-4-1-5-3 0-2 1-5 3-5 3-1 5 1 6 3zM615 292h-9c-5 1-8 4-9 3l2-2c1-2 3-3 6-4l8 1 2 2zM596 274h10l9 1-2 3-8 1-7-2c-2-1-2-2-2-3zM584 221c-62 1-43 77-43 77 23-23 43-63 43-63l9-3-9-11z",
    className: "st11"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M652 313c0-2 1-9 4-10 6-2 18-5 22 12 6 24-19 24-19 23l-7-25z",
    className: "st15"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M664 328h4c2-2 4-6 3-10l-3-6-3-2-2 1v2l-1-2v-1l3-1c1-1 3 1 5 2l3 6c0 5-1 10-4 12h-4l-1-1z",
    className: "st16"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M693 311c-2-37-23-83-44-91-20-7-65-18-69 10-2 18 22 30 39 37 5 3 11 5 15 10 5 6-6 35 18 47l1-19c2-3 10-5 17-2 8 3 17 28-7 35l5 31s26-20 25-58z",
    className: "st11"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m617 312-7 1-6 2 6-3h7zM567 324h-6l-6 1 6-1h6zM617 346v-3l-1-3 2 2-1 4z",
    className: "st16"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m689 288-2-5-10-8-8-4-10-5-21-10-22-10a704 704 0 0 0-18-9l-10-8c-3-2-3-4-3-4l3 4 10 8a214 214 0 0 0 18 8l22 10 21 11a704 704 0 0 0 24 13l4 4 1 3v1l1 1zM680 258h-1l-2-2a89 89 0 0 0-25-11 526 526 0 0 0-40-11 90 90 0 0 1-24-13l-2-3h-1 1l2 2 9 7 16 6 19 6 20 5a105 105 0 0 1 25 12l3 2z",
    className: "st10"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M708 376c13 0 26 7 33 18 8 12 9 26 12 40 2 14 7 28 20 35l3 3c1 2-1 4-3 5l-6-2c8 11 8 27-1 37-8 10-23 14-35 8l-40-118 17-26z",
    className: "st11"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M705 365c-4-2-9 1-12 4-5 5-7 11-10 17 1 3-2 8 1 11 2 3 6 5 10 4 5 0 8-5 10-9 3-5 4-10 5-15 0-5 0-10-4-12z",
    className: "st10"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m444 423 46 62 37 45-6 64s-36-17-46-37l-57-107 26-27z",
    className: "st15"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M671 370s-26 15-34 22l-36 30 2 8-16 54c-2 9-8 99-9 114h164s0-113-7-133c-10-31-48-77-48-77l-12-3-4-15z",
    className: "st2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m614 455-51 51s-12 2-14 11l-14 5c-1-3-12-5-14 2l-15 62c0 7 21 12 21 12l20-6 38-3c5-2 68-22 87-42l39-41s-61-71-97-51z",
    className: "st2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M521 524v-1c1 0 1-2 3-2h13l11-3 2-3c1-2 2-4 5-6l8-4v1l9-10 32-32 9-10 3-2v-1h1l-1 1-3 3-9 9-31 33-10 9c-6 1-11 5-13 10l-1 2-12 4c-5-2-10-2-13-1l-3 2v1z",
    className: "st11"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M583 589c26-2 52-7 75-20 22-13 40-35 44-60-27 41-68 67-119 80z",
    className: "st17"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M701 509v1l-1 1-3 4-2 4-3 3-7 9-5 5-5 5-3 3-3 2-6 5a209 209 0 0 1-71 36h-2l-2 1-4 1-7 1-6 1-12 1h-15 15l12-2 6-1 7-1 4-1h2l2-1 8-2a206 206 0 0 0 63-33l6-5 3-3 3-3 5-5 5-4 7-9 3-4 2-3 3-4 1-1v-1zM707 482v-1l-1-3-3-10-9-12a46 46 0 0 0-34-15l-15 1-11 1-2 1h-1 1l3-1a150 150 0 0 1 26-3 47 47 0 0 1 46 38v4zM675 388l-1 1-2 2-9 7-28 22-24 19h-1l-6-13-2-3v-1 1l2 3 7 13 24-20 28-22 8-7 3-1 1-1zM664 402zM680 598z",
    className: "st11"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m602 423 7 25 55-51-51 41",
    className: "st17"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M527 598v-1l1-2 2-8a241 241 0 0 0 5-61v-3 3l1 8a205 205 0 0 1-9 63v1zM542 563v-6a129 129 0 0 0 0 5v1zM559 565l-1-2v-6a147 147 0 0 0-6-33l-1-5-1-2a57 57 0 0 0 3 6 112 112 0 0 1 6 34v8z",
    className: "st11"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M396 400s-5-5-8-4c-4 0-4 6-4 6-1 3 8 12 11 17l25 34 29-21-1-8c-1-7-15-35-15-35l-17-28c-3-3-19-10-19-11 0 0-5 6-1 9l11 8 8 14v1l-9-13s-3-3-7-3c-3-1-8 1-8 1s-3 2-2 6l2 2 3 1 7 10s-6-4-8-2-3 4-3 7l6 9z",
    className: "st15"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m424 382-3 1-2 2v-1l2-2 2-1 1 1zM406 393l-4-4-3-4 4 4 3 4zM400 406l-3-4-2-3 2 3 3 4z",
    className: "st16"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m603 430-1 2-1 6-5 18-6 17-2 6v2-2l2-6a544 544 0 0 0 13-43zM756 598zM207 279v-3l2-8 7-32 24-104 1-2v2l1 2 23 106 8 32 2 9v3-1l-1-2-2-9-7-32-24-106-1-2h1l-24 104-8 32-2 9v2zM207 310v-26h70v26c0 17-14 31-31 31h-9c-17 0-30-14-30-31z",
    className: "st11"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M207 284a65 65 0 0 0 3 4l7 12 25 40 1 1h-1l24-40 8-13 2-3 1-1-1 1-2 3-7 13-24 40h-1l-25-40-8-13-2-3v-1zM249 131a8 8 0 1 1-16 0 8 8 0 0 1 16 0zM241 1z",
    className: "st11"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m245 344-3 3c-1 0-4-1-4-3s2-4 4-4 3 2 3 4z",
    className: "st11"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M240 345h1l-4 5 1 7 1 1 1-1v-4l2 4 1 1v-1l1-3 1 2 2 1v-2c0-4-2-8-4-11",
    className: "st11"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M211 284s-31-36-28-37c4-2 32 18 32 18s-24-53-20-57c5-4 30 47 30 47s-3-75 0-76c4-1 19 75 19 75s21-69 27-69-6 67-6 67 25-43 29-37c4 5-18 52-18 52s32-27 33-24c2 4-34 41-34 41h-64zM207 230zM232 236z",
    className: "st0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m267 203-1 3-2 9a941 941 0 0 0-19 70v-1l1-2a468 468 0 0 1 17-68l3-8 1-3zM282 241zM222 283l-3-2a66 66 0 0 1-13-14l7 8 9 8zM241 269l1 7v8l-1-7v-8z",
    className: "st0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m277 300-3 1a199 199 0 0 1-32 3 165 165 0 0 1-35-2h3l7 1a182 182 0 0 0 49-1l8-1 3-1zM277 308l-3 1a199 199 0 0 1-32 3 165 165 0 0 1-35-3l3 1 7 1a182 182 0 0 0 49-1l8-1 3-1z",
    className: "st8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationError01);
export default __webpack_public_path__ + "static/media/activation_error-01.a0069af999f5dc9f2c478d130a70cae9.svg";
export { ForwardRef as ReactComponent };